<template>
  <Card class="job-detail">
    <ConsoleLogOutput ref="ConsoleLogOutput"></ConsoleLogOutput>
    <ChangesLog ref="ChangesLog"></ChangesLog>
    <Build ref="Build" v-on:buildComplete="buildComplete"></Build>
    <Row :style="{marginBottom: '10px'}">
      <div :style="{float: 'left'}">
        <Button size="small"
                icon="ios-arrow-back"
                @click="$router.push({name: 'jenkins_detail', params: { id: $route.params.id }, query: { page: $route.query.lastPage }})">返回列表</Button>
      </div>
    </Row>
    <div class="content">
      <div class="main">
        <div>
          <Spin fix v-if="loading"></Spin>
          <Row style="margin-bottom: 10px">
            <Col :lg="14">
              <Row class="title">
                <h4 :style="{float: 'left'}">Job详情 <a v-on:click="getInfo"><Icon type="md-refresh" /></a></h4>
              </Row>
              <Alert v-if="infoError" type="warning" show-icon>获取数据失败</Alert>
              <div class="info-property" v-else style="margin-bottom: 10px">
                <dl>
                  <dt>Job名称</dt><dd>{{ info.name }}</dd>
                </dl>
                <dl>
                  <dt>描述</dt><dd>{{ info.description }}</dd>
                </dl>
                <dl>
                  <dt>URL</dt><dd><a target="_blank" :href="info.url">{{ info.url }}</a></dd>
                </dl>
                <dl>
                  <dt>是否可构建</dt><dd>{{ info.buildable ? '是' : '否' }}</dd>
                </dl>
                <dl>
                  <dt>在队列中</dt><dd>{{ info.inQueue ? '是' : '否' }}</dd>
                </dl>
                <dl>
                  <dt>上次构建</dt>
                  <dd v-if="info.lastBuild">
                    <span><a target="_blank" :href="info.lastBuild.url">#{{ info.lastBuild.number }}</a></span>
                  </dd>
                </dl>
                <dl>
                  <dt>上次构建状态</dt>
                  <dd>
                    <Tag v-if="info.color === 'blue'" color="green">成功</Tag>
                    <Tag v-else-if="info.color === 'disabled'" color="default">禁用</Tag>
                    <Tag v-else-if="info.color === 'red'" color="red">失败</Tag>
                    <Tag v-else-if="info.color === 'aborted'" color="gold">已终止</Tag>
                    <Tag v-else-if="info.color === 'notbuilt'" color="blue">未构建</Tag>
                    <Tag v-else-if="info.color.indexOf('anime') > -1" color="blue">构建中</Tag>
                    <Tag v-else color="gold">{{ info.color }}</Tag>
                  </dd>
                </dl>
              </div>
              <Row>
                <div style="text-align: right; padding: 0 10px" v-if="info.buildable || !loading">
                  <Button type="primary" @click="build" :loading="info.inQueue || info.color.indexOf('anime') > -1">
                    <span v-if="parameterBuild">参数化构建</span>
                    <span v-else>立即构建</span>
                  </Button>
                </div>
              </Row>
              <Row v-if="buildInfo || info.inQueue">
                <Row class="title">
                  <h4 :style="{float: 'left'}">控制台输出</h4>
                </Row>
                <div v-if="buildInfo">
                  <pre style="white-space: pre-wrap; word-wrap: break-word;">{{ buildInfo }}</pre>
                  <p v-if="info.color.indexOf('anime') > -1"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon></p>
                </div>
                <div v-else>
                  <Spin fix>
                    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                    <span>
                      <span style="padding-right: 10px"> 队列中</span>
                      <a style="color: red;" slot="extra" v-on:click="cancelQueue" v-if="$store.state.user.superuser"><Icon type="md-close-circle" size="16" /></a>
                    </span>
                  </Spin>
                </div>
              </Row>
            </Col>
            <Col :lg="10">
              <Row class="title">
                <h4 :style="{float: 'left'}">构建历史</h4>
              </Row>
              <Alert v-for="item in info.builds" :key="item.number" :type="item.result === 'SUCCESS' ? 'success' : 'error'">
                <span style="padding-right: 10px">{{ item.building ? '构建中......' : item.result }}</span>
                <a target="_blank" :href="item.url" style="padding-right: 10px">#{{ item.number }}</a>
                <span style="color: #999; padding-right: 10px">{{ moment(item.timestamp).format('YYYY-MM-DD HH:mm:ss') }}</span>
                <span style="float: right">
                  <a v-on:click="changeLogOpen(item)" style="padding-right: 8px">提交记录</a>
                  <a v-on:click="getConsoleOutput(item.number)" style="padding-right: 15px">控制台</a>
                  <a style="color: red;" v-on:click="cancelBuild(item.number)" v-if="item.building"><Icon type="md-close-circle" size="16" /></a>
                </span>
              </Alert>
              <Row class="title">
                <h4 :style="{float: 'left'}">操作日志</h4>
              </Row>
              <JobLogs ref="JobLogs" :jenkins-id="$route.params.id" :job-name="$route.params.job_name" class="job-logs-content"></JobLogs>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import { getJenkinsJobDetail, getJenkinsQueueItem, getJenkinsBuildConsole,
  cancelJenkinsBuildQueue, stopBuildJenkinsJob } from '@/api/tools/jenkins'
import ConsoleLogOutput from './components/console-output'
import ChangesLog from './components/changes-log'
import Build from './components/build'
import JobLogs from './components/job-log'
import moment from 'moment'

export default {
  name: 'job_detail',
  components: {
    ConsoleLogOutput,
    ChangesLog,
    Build,
    JobLogs
  },
  data () {
    return {
      info: {},
      buildInfo: '',
      infoError: false,
      moment: moment,
      loading: false,
      timer: null,
      currentBuildNumber: null,
      currentQueueNumber: null,
      parameterBuild: false
    }
  },
  created: function () {
    this.init()
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  watch: {
    '$route' () {
      if (this.$route.params.id && this.$route.params.job_name) {
        this.init()
      }
    },
    currentBuildNumber () {
      if (this.currentBuildNumber) {
        this.setTimer('build', 1000)
      }
    },
    currentQueueNumber () {
      if (this.currentQueueNumber) {
        this.setTimer('queue')
      }
    }
  },
  methods: {
    // 初始化
    init () {
      this.buildInfo = ''
      clearInterval(this.timer)
      this.timer = null
      this.getInfo()
    },
    // 获取Job信息
    getInfo (loading = true) {
      this.infoError = false
      this.loading = loading
      getJenkinsJobDetail(this.$route.params.id, this.$route.params.job_name).then(res => {
        this.info = res.data
        for (let i in this.info.property) {
          if (this.info.property[i]._class === 'hudson.model.ParametersDefinitionProperty') {
            this.parameterBuild = true
            break
          }
        }
        if (loading) {
          if (this.info.queueItem && !this.currentQueueNumber) {
            this.currentQueueNumber = this.info.queueItem.id
          } else {
            if (this.info.color.indexOf('anime') > -1) {
              this.currentBuildNumber = this.info.lastBuild.number
            }
          }
        } else {
          if (!this.info.queueItem && this.info.color.indexOf('anime') <= -1) {
            this.currentQueueNumber = null
            this.currentBuildNumber = null
            clearInterval(this.timer)
            this.timer = null
          }
        }
        this.loading = false
      }).catch(res => {
        this.loading = false
        console.log(res.response)
        this.infoError = true
      })
    },
    // QueueItem
    getQueueItem () {
      getJenkinsQueueItem(this.$route.params.id, this.currentQueueNumber).then(res => {
        if (res.data.executable) {
          this.currentBuildNumber = res.data.executable.number
        } else {
          if (res.data.cancelled) {
            clearInterval(this.timer)
            this.timer = null
            this.currentQueueNumber = null
          }
        }
      })
    },
    // 控制台输出
    getConsoleOutput (buildNumber) {
      this.$refs.ConsoleLogOutput.getOutput(this.$route.params.id, this.$route.params.job_name, buildNumber)
    },
    // 自动刷新
    setTimer (type, timer = 2000) {
      clearInterval(this.timer)
      this.timer = null
      if (this.timer == null) {
        this.timer = setInterval(() => {
          if (type === 'queue') {
            this.getQueueItem()
          } else {
            this.getBuildInfo()
          }
        }, timer)
      }
    },
    // Build Info
    getBuildInfo () {
      if (this.currentBuildNumber) {
        getJenkinsBuildConsole(this.$route.params.id, this.$route.params.job_name, this.currentBuildNumber).then(res => {
          this.buildInfo = res.data.output
          this.getInfo(false)
        }).catch(res => {
          this.buildInfo = ''
        })
      }
    },
    // 构建
    build () {
      this.buildInfo = ''
      this.$refs.Build.start(this.$route.params.id, this.$route.params.job_name)
    },
    // 构建完成
    buildComplete (jobName, queueNumber) {
      this.getInfo(false)
      this.currentQueueNumber = queueNumber
    },
    // 移除构建队列
    cancelQueue () {
      cancelJenkinsBuildQueue(this.$route.params.id, this.currentQueueNumber).then(res => {
        this.getInfo(false)
      }).catch(res => {
        this.getInfo(false)
      })
    },
    cancelBuild (buildNumber) {
      stopBuildJenkinsJob(this.$route.params.id, this.$route.params.job_name, buildNumber).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getInfo()
      }).catch(res => {
        console.log(res.response)
        if (res.request) {
          this.$Notice.error({
            title: '取消构建失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '取消构建失败！'
          })
        }
      })
    },
    changeLogOpen (item) {
      let changeSet = item.changeSet ? [item.changeSet] : item.changeSets
      this.$refs.ChangesLog.openModal(changeSet)
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  .job-logs-content {
    padding: 0;
    overflow-y: auto;
    max-height: 400px;
    padding-bottom: 5px;
    padding-right: 5px;
  }
  .job-logs-content::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }
  .job-logs-content::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .job-logs-content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
